const PHONE_DISPLAY = '0493 035 628';
const PHONE_HREF = 'tel:0493035628';

function PhoneIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" className={className}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 4.5h3l1.5 5.25-2.25 1.5a11.25 11.25 0 0 0 6.75 6.75l1.5-2.25 5.25 1.5v3a1.5 1.5 0 0 1-1.5 1.5A16.5 16.5 0 0 1 3 6a1.5 1.5 0 0 1 1.5-1.5z"
      />
    </svg>
  );
}

/**
 * Fixed call-to-action bar shown only on mobile viewports, so the phone
 * number stays reachable while scrolling. Desktop already has a persistent
 * call button in the header, and a `tel:` link there isn't the "obvious tap
 * to dial" action a desktop pointer/keyboard user expects, so this is
 * deliberately mobile-only.
 */
export function MobileCallCta() {
  return (
    <a href={PHONE_HREF} className="mobile-call-cta md:hidden" aria-label={`Call Meet Real Estate on ${PHONE_DISPLAY}`}>
      <PhoneIcon className="mobile-call-cta__icon" />
      Call {PHONE_DISPLAY}
    </a>
  );
}
